import React, { FC } from "react";

interface ArtistsSearchBoxProps {
  onChange: (value?: string) => void;
}

const ArtistsSearchBox: FC<ArtistsSearchBoxProps> = ({ onChange }) => {
  return (
    <div className="artists-search-box">
      <input
        onChange={(ev) => onChange(ev.currentTarget.value)}
        placeholder="search by artist name"
        aria-label="search by artist name"
      />
    </div>
  );
};

export { ArtistsSearchBox, ArtistsSearchBoxProps };
